import { format, parse } from 'date-fns'
import enLocale from 'date-fns/locale/en'
import { useSelector } from 'react-redux'
import { getUserSettings } from '../reducers/userObject/selectors/settings'
import { dateFormat } from '../utils/DateFormat'

export default function useFormatDate() {
  const settings = useSelector(getUserSettings)
  const dateFormatString = settings.dateFormat

  return (date: Date) =>
    date
      ? format(
          parse(date),
          dateFormat(
            dateFormatString && dateFormatString.date
              ? dateFormatString.date
              : 'dd/MM/yyyy',
          ),
          {
            locale: enLocale,
          },
        )
      : ''
}

export function useFormatDateString() {
  const settings = useSelector(getUserSettings)
  const dateFormatString = settings.dateFormat

  return dateFormatString && dateFormatString.date
    ? dateFormatString.date
    : 'dd/MM/yyyy'
}
